export const GUARANTY_CLAIMS_REQUEST_PENDING = 'guranty_claims_request_pending';
export const GUARANTY_CLAIMS_REQUEST_RECEIVED = 'guranty_claims_request_received';
export const GUARANTY_CLAIMS_REQUEST_ERROR = 'guranty_claims_request_error';
